import api from '../../api/mas-athena';

const state = {
    conferences: [],
    conference: []
    //event_id: window.localStorage.getItem('event_id')
};

const getters = {
    allConferences: state => state.conferences,
    getConferenceDetails: state => state.conference
};

const actions = {
    async fetchConferences({ commit }, event_id) {
        const response = await api.fetchConferences(event_id);

        commit('setConferences', await response.data.results);
        //window.localStorage.setItem('event_id', event_id);
    },
    async getConference({ commit }, conference_id) {
        const response = await api.getConference(conference_id)
        
        commit('setConference', await response.data.results);
    }
};

const mutations = {
    setConferences: (state, conferences) => {
        state.conferences = conferences
    },
    setConference: (state, conference) => {
        state.conference = conference
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}